import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ScheduleSlot from 'frontend/schedule/schedule-slot'
import classNames from 'classnames'
import moment from 'lib/moment-timezone-custom'

export default function ScheduleDay (
  { date, onSlotSelect, onGameRemove, selectedTime, selectedPlayersCount, showAdvanceDiscount = true, ...props }
) {
  const isToday = useMemo(() => moment().isSame(date.date, 'day'), [date.date])
  const isWeekAway =
    showAdvanceDiscount && useMemo(() => moment(date.date).diff(moment()) > 604800000, [date.date])
  const isSelected = useMemo(
    () => selectedTime && selectedTime.isSame(date.date, 'day'), [selectedTime, date.date]
  )

  return (
    <div
      className={classNames('schedule_day', { selected: isSelected })}
      data-date={moment(date.date).format('YYYY-MM-DD')}
    >
      <div className="header">
        <div className="day_name_and_date_place">
          <div className="day_name">{moment(date.date).format('dddd')}</div>
          <div className="date">{moment(date.date).format('D MMM')}</div>
          {isToday && <div className="today">Today</div>}
        </div>
        {isWeekAway && (
          <div className="discount_label">
            <div className="value">$10 off</div>
            <div className="description">7 Day Advance Discount is Applied</div>
          </div>
        )}
      </div>
      {date.timeSlots.map(timeSlot => {
        return (
          <ScheduleSlot
            key={timeSlot.time}
            timeSlot={timeSlot}
            selectedTime={selectedTime}
            playersCount={selectedPlayersCount}
            onSelect={onSlotSelect}
            onRemove={onGameRemove}
            {...props}
          />
        )
      })}
    </div>
  )
}

ScheduleDay.propTypes = {
  date: PropTypes.object.isRequired,
  onSlotSelect: PropTypes.func.isRequired,
  onGameRemove: PropTypes.func.isRequired,
  selectedTime: PropTypes.object,
  selectedPlayersCount: PropTypes.number,
  showAdvanceDiscount: PropTypes.bool
}
